import { defineComponent as d, createElementBlock as o, openBlock as t, mergeProps as f, unref as i, createBlock as c, createCommentVNode as a, renderSlot as l, withCtx as g, createTextVNode as k, toDisplayString as n, normalizeClass as u } from "vue";
import y from "../Title.vue2.js";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Login/login.js";
import { useOUIAProps as H } from "../../helpers/ouia.js";
const S = /* @__PURE__ */ d({
  name: "PfLoginMainHeader",
  __name: "LoginMainHeader",
  props: {
    title: {},
    subtitle: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(m) {
    const r = m, p = H({ id: r.ouiaId, safe: r.ouiaSafe });
    return (e, M) => (t(), o("header", f(i(p), {
      class: i(s).loginMainHeader
    }), [
      e.title ? (t(), c(y, {
        key: 0,
        h: 2,
        size: "3xl"
      }, {
        default: g(() => [
          k(n(e.title), 1)
        ]),
        _: 1
      })) : a("", !0),
      e.subtitle ? (t(), o("p", {
        key: 1,
        class: u(i(s).loginMainHeaderDesc)
      }, n(e.subtitle), 3)) : a("", !0),
      e.$slots.utilities ? (t(), o("div", {
        key: 2,
        class: u(i(s).loginMainHeaderUtilities)
      }, [
        l(e.$slots, "utilities")
      ], 2)) : a("", !0),
      l(e.$slots, "default")
    ], 16));
  }
});
export {
  S as default
};
